import { Commercial, TCommercialId, TEditId } from '@talon/web/lib/api';
import { useProjectStore } from '@talon/web/src/context';
import { Box, Spinner } from 'grommet';
import { observer } from 'mobx-react-lite';
import { CommercialEditRow } from './CommercialEditRow';

export type EditsPanelProps = {
  commercials: Commercial[];
  selected: TCommercialId[];
  setSelected: (selected: TCommercialId[]) => void;
  commercialId?: TCommercialId;
  editId?: TEditId;
};

export const EditsPanel = observer(({ commercials, selected, setSelected, commercialId, editId }: EditsPanelProps) => {
  /** Context **/
  const projectStore = useProjectStore();

  /** Methods **/
  const chooseCommercial = (id: string) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((s) => s !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  /** Render **/
  return (
    <Box pad="medium" gap="medium" background="light-1" overflow={{ vertical: 'scroll' }} flex="grow">
      {projectStore.currentProject ? (
        <Box gap="medium">
          {commercials.map((commercial) => (
            <CommercialEditRow
              key={commercial.id}
              commercialId={commercial.id}
              onChecked={() => chooseCommercial(commercial.id)}
              checked={selected.includes(commercial.id)}
              initialEditId={commercial.id === commercialId ? editId : undefined}
            />
          ))}
        </Box>
      ) : (
        <Box fill align="center" justify="center">
          <Spinner size="large" />
        </Box>
      )}
    </Box>
  );
});
